import { Title, Text, Container, Accordion, ThemeIcon, Group, Stack, Box, Image } from '@mantine/core';
import { IconChevronsDown, IconCircleCheck } from '@tabler/icons-react';
import { Question, QuestionType } from '@generated/graphql';
import SurveyQuestionDnd from '@components/questionnaire-choices-dnd';
import imageEarth from '@src/assets/qg-earth-scapes.webp';
import imageCulture from '@src/assets/qg-culture-scapes.webp';
import imageTime from '@src/assets/qg-time-scapes.webp';
import classes from './questionnaire.module.css';

interface QuestionnaireProps {
  title?: string;
  questions: Question[];
}

// function Questionnaire({ questions, title, context}: QuestionnaireProps) {
function Questionnaire({ questions, title }: QuestionnaireProps) {
  // TODO: add attribute to the question to determine the image, like "image: 'earth-scapes'"
  const getImage = (questionText: string) => {
    if (questionText === 'Earth Scapes') {
      return imageEarth;
    }
    if (questionText === 'Culture Scapes') {
      return imageCulture;
    }
    if (questionText === 'Time Scapes') {
      return imageTime;
    }
    return '';
  };

  const items = questions.map((question) => (
    <Accordion.Item key={question.id} className={classes.item} value={question.id.toString()}>
      <Accordion.Control>
        <Group gap="sm">
          {/* TODO add checkmarks when selected
          {question.id === '42' ? (
            <IconCircleCheck size="2.0rem" stroke={2.5} color="green" />
          ) : (
            <IconCircleCheck size="2.0rem" stroke={2.5} color="#f1f3f5" />
          )} */}
          {question.type === QuestionType.LayerGroup ? (
            <Image
              className={classes.thumbnail}
              w={125}
              h={125}
              src={getImage(question.text)}
              alt={question.text}
              radius="sm"
            />
          ) : (
            <IconCircleCheck size="2.0rem" stroke={2.5} color="var(--mantine-color-gray-3)" />
          )}

          <Stack gap={5}>
            <Text>{question.text}</Text>
            <Text c="dark.4" size="sm">
              {question.subtext}
            </Text>
          </Stack>
        </Group>
      </Accordion.Control>

      <Accordion.Panel>
        <Text c="red" fw={700} ta="center" pb={20}>
          {question.directions}
        </Text>
        <SurveyQuestionDnd question={question} />
      </Accordion.Panel>
    </Accordion.Item>
  ));

  return (
    <Container fluid>
      {title && (
        <Box bg="var(--mantine-color-voyTitleBox-6)" p={10} mb={30} mt={20}>
          <Title order={2} c="white" ta="center" className={classes.title}>
            {title}
          </Title>
        </Box>
      )}
      <Container size="sm">
        <Accordion
          chevronPosition="right"
          chevronSize={32}
          variant="separated"
          chevron={
            <ThemeIcon radius="xl" size={32}>
              <IconChevronsDown size="1rem" stroke={1.5} />
            </ThemeIcon>
          }
        >
          {items}
        </Accordion>
      </Container>
    </Container>
  );
}

export default Questionnaire;
